import { useVideoContext } from '../../hooks'

export const MeetLogo = () => {
  const { branding } = useVideoContext()

  return branding?.logo
}
